import { Key } from 'lucide-react'
import { FC, useState } from 'react'

import { CopyButton } from '@/components/global/copy-button'
import { RevealButton } from '@/components/global/reveal-button'
import SettingsCard from '@/components/settings-card'
import { Input } from '@/components/ui/input'

type Props = {
  webhookSecret: string
}

const WebhookSecretCard: FC<Props> = ({ webhookSecret }) => {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <SettingsCard
      Icon={Key}
      title="Webhook Secret"
      description={
        <>
          This secret is used to verify the authenticity of incoming webhook requests. An{' '}
          <span className="font-mono">X-Signature</span> header will be included with webhook requests.
        </>
      }
      sections={[
        <div key="webhook-secret">
          <div className="flex gap-2 items-center">
            <Input
              type="text"
              value={isVisible ? webhookSecret : webhookSecret.replace(/_(.+)$/, () => `_${'*'.repeat(32)}`)}
              readOnly
              className="font-mono truncate bg-muted-foreground/5"
              data-testid="webhook-secret-input"
            />
            <RevealButton isVisible={isVisible} onToggle={() => setIsVisible(!isVisible)} />
            <CopyButton text={webhookSecret} />
          </div>
          {/* <div className="mt-4">
            <Button size="sm" variant="outline">
              View code examples to verify the signature
            </Button>
          </div> */}
        </div>,
      ]}
      className="flex flex-col max-w-lg shadow-none min-w-md"
    />
  )
}

export default WebhookSecretCard
